var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTeam = function SvgTeam(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 30 30"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    fillRule: "evenodd",
    d: "M21.5 15c0 4.938-2.751 8.192-6.513 9.435-2.127-.622-3.582-1.155-4.614-2.252a5.1 5.1 0 0 1-.82-1.176L21.5 9.055V15m-.905-7.16-5.594-2.226L8.5 8.2 8.5 15c0 1.908.178 3.352.474 4.464zM7 15c0 8.546 3.414 9.683 8 11 4.587-1.317 8-5.198 8-11V7.182L15 4 7 7.182z",
    clipRule: "evenodd"
  })));
};
export default SvgTeam;